import React from 'react'
import Modal from '~/prix/react/components/modal'
import reports, { ReportBase } from './reports'
import { Layer } from '~/packages/general/variable/spaceTime.types'

interface MapRenderReportProps extends ReportBase {
  onClose: () => void
  layer: Layer
}

export default function MapReport({
  onClose,
  layer,
  reportKey,
  reportPayload,
}: MapRenderReportProps) {
  const Report = reports[reportKey as keyof typeof reports] as ({}: any) => JSX.Element
  if (!Report) {
    throw new Error(`Report ${reportKey} not found`)
  }
  const isFramelessReport = reportKey === 'selfComparison'

  return (
    <Modal
      isOpen
      onClose={onClose}
      className={isFramelessReport ? 'prix-modal-self-comparison' : undefined}
      baseWidth={isFramelessReport ? 'calc(100vw - 2rem)' : '1200px'}
      baseHeight={isFramelessReport ? '80dvh' : undefined}
      styles={
        isFramelessReport
          ? {
              content: {
                maxWidth: '1260px',
                background: 'transparent',
                boxShadow: 'none',
                borderRadius: 0,
                padding: 0,
                overflow: 'hidden',
              },
            }
          : undefined
      }
    >
      <Report layer={layer} {...reportPayload} />
    </Modal>
  )
}
